/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, ListSubheader, ListItemText } from "@mui/material";

export const StyledSubHeader = styled(ListSubheader)({
  lineHeight: "32px",
  color: "#9e9e9e",
  fontSize: "12px",
  letterSpacing: "0.5px",
})

export const StyledItemText = styled(ListItemText)({
  "& .MuiListItemText-primary": {
    fontSize: "14px",
  },
})
